import { render, staticRenderFns } from "./YogaStay.vue?vue&type=template&id=31adc43f&scoped=true&"
import script from "./YogaStay.vue?vue&type=script&lang=js&"
export * from "./YogaStay.vue?vue&type=script&lang=js&"
import style0 from "./YogaStay.vue?vue&type=style&index=0&id=31adc43f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31adc43f",
  null
  
)

export default component.exports